import { ADD_TOOL, UPDATE_TOOL, DELETE_TOOL } from '../actions/tools';
import { SELECT_SITE, UNSELECT_SITE, UPDATE_SITE } from '../actions/sites';
import { SERIALIZE_DIAGNOSTIC } from '../actions/diagnostic';

export default function(state = false, action) {
  switch (action.type) {
    case ADD_TOOL:
    case UPDATE_TOOL:
    case DELETE_TOOL:
    case SELECT_SITE:
    case UNSELECT_SITE:
    case UPDATE_SITE:
      return true;
    case SERIALIZE_DIAGNOSTIC:
      return action.hasChanges ? true : false;
    default:
      return state;
  }
}

export const getIsDirty = state => state.siteCase.dirty;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/reducers/dirty.js